// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-signed-in-button{
    /* background-color: linear !important; */
    background-image: linear-gradient(to right,  rgba(36, 39, 63, 0.8), rgba(30, 35, 67, 0.949), rgb(22, 26, 53)) !important;
    color: white !important;
    font-size: 14px;
    height: 40px;
    padding: 5px 15px 5px 15px !important;
    width: 100%;
    border-radius: 7px !important;
    transform: translateY(15px);
}

.error-404-head{
      background: -webkit-gradient(left,right,from(#cc9f8b),to(#d07898));
      background: linear-gradient(90deg, #dd5252, #df3838, #e81111, #e50d0d, #d90707, #c00000);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;
      /* font-size: 45px !important; */
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/error-page/err.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,wHAAwH;IACxH,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;MACM,kEAAkE;MAClE,wFAAwF;MACxF,6BAA6B;MAC7B,qBAAqB;MACrB,oCAAoC;MACpC,iBAAiB;MACjB,gCAAgC;AACtC","sourcesContent":[".not-signed-in-button{\n    /* background-color: linear !important; */\n    background-image: linear-gradient(to right,  rgba(36, 39, 63, 0.8), rgba(30, 35, 67, 0.949), rgb(22, 26, 53)) !important;\n    color: white !important;\n    font-size: 14px;\n    height: 40px;\n    padding: 5px 15px 5px 15px !important;\n    width: 100%;\n    border-radius: 7px !important;\n    transform: translateY(15px);\n}\n\n.error-404-head{\n      background: -webkit-gradient(left,right,from(#cc9f8b),to(#d07898));\n      background: linear-gradient(90deg, #dd5252, #df3838, #e81111, #e50d0d, #d90707, #c00000);\n      -webkit-background-clip: text;\n      background-clip: text;\n      -webkit-text-fill-color: transparent;\n      font-weight: bold;\n      /* font-size: 45px !important; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
